import { render } from "./SectionTravelAnalytics.vue?vue&type=template&id=4b35e74e&scoped=true"
import script from "./SectionTravelAnalytics.vue?vue&type=script&lang=js"
export * from "./SectionTravelAnalytics.vue?vue&type=script&lang=js"

import "./SectionTravelAnalytics.vue?vue&type=style&index=0&id=4b35e74e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b35e74e"]])

export default __exports__